// removed by extract-text-webpack-plugin
module.exports = {"emptyView":"_2H7eXP2ub13AHqWU"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectsList.pcss
// module id = 507
// module chunks = 1